const pubTeamMatch = [{
  value: '1',
  label: '岚悦'
}, {
  value: '2',
  label: '随悦'
}, {
  value: '3',
  label: '艾瑞'
}, {
  value: '4',
  label: '深圳中手游'
}, {
  value: ' 5',
  label: '成都卓星'
}, {
  value: '6',
  label: '豆悦'
}, {
  value: '7',
  label: '静思(联运)'
}, {
  value: '8',
  label: '鼎盛(联运)'
}, {
  value: '9',
  label: '长沙捷途(联运)'
}, {
  value: '10',
  label: '金豆(联运)'
}, {
  value: '11',
  label: '新天互娱(审计)(联运)'
}, {
  value: '12',
  label: '红鲸(审计)(联运)'
}, {
  value: '13',
  label: '上海晟尧(联运)'
}, {
  value: '14',
  label: '中手游主体备用'
}, {
  value: '15',
  label: '思璞'
}, {
  value: '16',
  label: '大树互娱'
}, {
    value: '17',
    label: '三七'
  }, {
    value: '18',
    label: '红龙'
  }]

export function pubTeamMatchFun(value) {
  for (var i = 0; i < pubTeamMatch.length; i++) {
    if (pubTeamMatch[i].value == Number(value)) {
      return pubTeamMatch[i].label;
    }
  }
}

export function pubTeamData() {
  return pubTeamMatch;
}
// export default matchList



// WEBPACK FOOTER //
// ./src/utils/pubTeam.js